import React from 'react';
import SearchFormTabs from '../SearchFormTabs';
import { getCMSWidgetComponent } from '../cmsLib';
import { Grid } from 'material-ui';
/**
 * Landing custom header
 * 
 * @author Luciano Bustos
 */
class SearchHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }
    render() {
        const {isDisabled} = this.props;
        const cmsConfiguration = JSON.parse(window.localStorage.getItem('cmsConfiguration'));
        // Analizamos si el widget 1 es de tipo carrousel, y ese caso lo tiramos hacia arriba.
        const widget1 = cmsConfiguration.layout.widgets[0];
        const widget1Active = !widget1.hidden;
        const className = widget1.type === 'CarrouselWidget' ? 'pull-to-top' : '';
        return (<div className="cmsSearchHeader">
            <Grid container justify="center">
                <Grid item xs={6}>
                    <SearchFormTabs widget1Active={widget1Active} isDisabled={this.props.isDisabled} />
                </Grid>
                <Grid item xs={6}>
                    {getCMSWidgetComponent(1, {}, className)}
                </Grid>
            </Grid>
        </div>
        );
    }
}

export default (SearchHeader);


// WEBPACK FOOTER //
// ./src/cms/headers/SearchHeader.js